import * as React from 'react';

import { $catalyticItems } from '@rematter/modules/trade/_state/loadForm.state';
import { useCatalyticSizeOptions } from '@rematter/modules/trade/hooks/useCatalyticSizeOptions';
import { useTranslations } from '@rematter/modules/trade/i18n/useTranslations';
import { CatalyticConverterSize } from '@rematter/modules/trade/types/load';
import { TouchSelect } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { LoadStagedFieldProps } from '../_types';

export const ItemSizeField: React.FC<LoadStagedFieldProps> = ({
  lineItem,
  disabled,
  onUpdateItem,
  onFocus,
  onBlur,
}) => {
  const t = useTranslations();
  const catalyticItems = useAtomValue($catalyticItems);

  const currentItem = React.useMemo(
    () => catalyticItems.find((item) => item.id === lineItem.itemId),
    [catalyticItems, lineItem.itemId],
  );

  const { currentSize, availableSizeOptions, findItemIdForSize } =
    useCatalyticSizeOptions(currentItem);

  const handleChangeOption = React.useCallback(
    (selectedSize?: string) => {
      if (!selectedSize) return;

      const matchingItemId = findItemIdForSize(
        selectedSize as CatalyticConverterSize,
      );

      if (matchingItemId) {
        onUpdateItem(lineItem.id, { itemId: matchingItemId });
      }
    },
    [findItemIdForSize, lineItem.id, onUpdateItem],
  );

  if (availableSizeOptions.length === 0) {
    return null;
  }

  return (
    <TouchSelect
      value={currentSize}
      onChange={handleChangeOption}
      onFocus={onFocus}
      onBlur={onBlur}
      isDisabled={disabled || availableSizeOptions.length <= 1}
      options={availableSizeOptions}
      variant="outlined"
      className="@ItemSizeField"
      prefix={
        <span className="text-xs font-semibold text-neutral/60 uppercase">
          {t.loadStaged.placeholders.sizeItem}
        </span>
      }
    />
  );
};
